/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import toast from 'react-hot-toast';
import { ExternalLinkIcon } from '@heroicons/react/solid';

import { DocumentDuplicateIcon } from '@heroicons/react/outline';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import * as S from './styles';

export interface multiColData {
  key: string;
  title: string;
  subtitle: string;
  icon: string;
}

export interface IMultiColListProps {
  data: multiColData[];
  numberOfColumns: '1' | '2' | '3' | '4';
}

function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

function start_and_end(str) {
  if (str && str.length > 25) {
    return (
      str.substr(0, 10) + '.....' + str.substr(str.length - 10, str.length)
    );
  }
  return str;
}

export const MultiColList = (props: IMultiColListProps) => {
  const { data, numberOfColumns } = props;

  const _renderColSize = () => {
    switch (numberOfColumns) {
      case '1':
        return 12;
      case '2':
        return 6;
      case '3':
        return 4;
      case '4':
        return 3;
      default:
        return 4;
    }
  };
  const _renderSubtitleIf = (subtitle: string) => {
    console.log(`in _renderSubtitleIf: `, subtitle, typeof subtitle);
    if (subtitle && typeof subtitle === 'string') {
      const popover = (
        <Popover id="popover-basic">
          <Popover.Body>{subtitle}</Popover.Body>
        </Popover>
      );

      const popover1 = (
        <Popover id="popover-basic">
          <Popover.Body>{'Copy to clipboard'}</Popover.Body>
        </Popover>
      );

      if (subtitle && subtitle?.length > 25) {
        if (isValidHttpUrl(subtitle)) {
          return (
            <>
              <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
                <span>{subtitle && start_and_end(subtitle)}</span>
              </OverlayTrigger>
              <OverlayTrigger
                trigger="hover"
                placement="top"
                overlay={popover1}
              >
                <DocumentDuplicateIcon
                  onClick={() => {
                    toast.success('copied!');
                    navigator.clipboard.writeText(subtitle);
                  }}
                  className="icon icon-xs ms-2"
                  color="#858585"
                  style={{ cursor: 'pointer' }}
                />
              </OverlayTrigger>
              <a href={subtitle} target="_blank">
                <ExternalLinkIcon
                  className="icon icon-xs ms-2"
                  color="#858585"
                />
              </a>
            </>
          );
        } else {
          return (
            <>
              <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
                <span>{subtitle && start_and_end(subtitle)}</span>
              </OverlayTrigger>
              <OverlayTrigger
                trigger="hover"
                placement="top"
                overlay={popover1}
              >
                <DocumentDuplicateIcon
                  color="#858585"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    toast.success('copied!');
                    navigator.clipboard.writeText(subtitle);
                  }}
                  className="icon icon-xs ms-2"
                />
              </OverlayTrigger>
            </>
          );
        }
      } else return subtitle;
    } else if (subtitle && typeof subtitle === 'object' && subtitle?.val) {
      return subtitle?.val;
    } else return '';
  };
  const _renderList = () => {
    return (
      <>
        {data.map((item, index) => {
          return (
            <Col xs={12} md={_renderColSize()} key={`${item?.key}-${index}`}>
              <ListGroup>
                <S.IconContainer>
                  {item?.icon && <S.IconImage src={item?.icon} />}
                  <div className="px-3 pb-2">
                    {/*<S.Title className="fs-6 mb-0 pb-0">*/}
                    {/*  {item?.title ?? ""}*/}
                    {/*</S.Title>*/}
                    <S.Title className="text-dark mb-0 w-100 align-justify">
                      {item?.title ?? ''}
                    </S.Title>
                    <S.SubTitle
                      className=" mb-0 w-100 align-justify"
                      style={{ wordBreak: 'break-word' }}
                    >
                      {_renderSubtitleIf(item?.subTitle)}
                    </S.SubTitle>
                  </div>
                </S.IconContainer>
              </ListGroup>
            </Col>
          );
        })}
      </>
    );
  };
  return <Row className="flex-start">{_renderList()}</Row>;
};

MultiColList.defaultProps = {
  data: [],
  numberOfColumns: '3',
};
